/* eslint-disable react/display-name */
import { ReactElement, forwardRef } from "react";
import CarItemUnitDropDownMenuTitle from "./CartItemUnitDropDownMenuTitle";

type props = {
  children: ReactElement[];
  style: React.ReactHTMLElement<HTMLDivElement>["props"]["style"];
  className: React.ReactHTMLElement<HTMLDivElement>["props"]["className"];
  "aria-labelledby": React.ReactHTMLElement<HTMLDivElement>["props"]["aria-labelledby"];
};
type TRef = React.ReactHTMLElement<HTMLDivElement>["ref"];

const CartUnitDropDownMenu = forwardRef(
  (
    { children, style, className, "aria-labelledby": labeledBy }: props,
    ref: TRef,
  ) => {
    return (
      <div
        ref={ref}
        className={`${className} p-0`}
        style={style}
        aria-labelledby={labeledBy}
      >
        <div className="cart-item-units-menu">
          <CarItemUnitDropDownMenuTitle />
          {children}
        </div>
      </div>
    );
  },
);

export default CartUnitDropDownMenu;
